/**
 * Chilean country code
 */
export const CHILEAN_COUNTRY_CODE = '56';
/**
 * Chilean locale code
 */
export const CHILEAN_LOCALE = 'es-CL';
/**
 * Chilean peso currency code
 */
export const CLP_CURRENCY = 'CLP';
/**
 * Minimum fraction digits for currency formatting
 */
export const CURRENCY_MIN_FRACTION_DIGITS = 0;
/**
 * Currency style for number formatting
 */
export const CURRENCY_STYLE = 'currency';
/**
 * Ellipsis character for text truncation
 */
export const ELLIPSIS = '...';
/**
 * Phone number length with country code
 */
export const PHONE_LENGTH_WITH_COUNTRY = 11;
/**
 * Phone number length without country code
 */
export const PHONE_LENGTH_WITHOUT_COUNTRY = 9;
/**
 * Snake case separator
 */
export const SNAKE_CASE_SEPARATOR = '_';
/**
 * Space separator
 */
export const SPACE_SEPARATOR = ' ';
/**
 * Maximum fraction digits for UF formatting
 */
export const UF_MAX_FRACTION_DIGITS = 2;
/**
 * Minimum fraction digits for UF formatting
 */
export const UF_MIN_FRACTION_DIGITS = 2;
